import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
export function useAnnouncementStorage() {
    return useStorageClient('announcement');
}
